import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FractionationTypeLabel } from "@shared/enums/fractionationTypeLabel.type";
import { BankInformationPolicyVm } from "@shared/models/policy-details";
import { MaskIbanPipe } from "@shared/pipes/mask-iban.pipe";

@Component({
  selector: "app-payment-informations",
  standalone: true,
  imports: [CommonModule, TranslateModule, MaskIbanPipe],
  templateUrl: "./payment-informations.component.html",
})
export class PaymentInformationsComponent {
  @Input() paymentInformations!: BankInformationPolicyVm;
  fractionationTypeLabel = FractionationTypeLabel;
}
